import { useEffect, useRef, useState } from "react"

let loading
function loadRecaptcha() {
  if (window.grecaptcha && window.grecaptcha.render) return Promise.resolve(window.grecaptcha)
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      const timer = setTimeout(() => reject(new Error("Timeout")), 15000)
      window.yetiRecaptchaReady = () => {
        clearTimeout(timer)
        resolve(window.grecaptcha)
      }
      script.src = "https://www.google.com/recaptcha/api.js?onload=yetiRecaptchaReady&render=explicit&hl=es"
      script.async = true
      script.defer = true
      script.onerror = () => {
        clearTimeout(timer)
        reject(new Error("Load failed"))
      }
      document.head.appendChild(script)
    })
  }
  return loading
}

export default function Recaptcha({ onChange, resetCount }) {
  const container = useRef(null)
  const widget = useRef(null)
  const callback = useRef(onChange)
  callback.current = onChange
  const [error, setError] = useState("")
  const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY

  useEffect(() => {
    if (!sitekey) {
      setError("El formulario no está disponible temporalmente.")
      return
    }
    let active = true
    const host = container.current
    loadRecaptcha().then(api => {
      if (!active) return
      const target = document.createElement("div")
      host.appendChild(target)
      widget.current = api.render(target, {
        sitekey,
        callback: token => { if (active) { setError(""); callback.current(token) } },
        "expired-callback": () => { if (active) callback.current("") },
        "error-callback": () => {
          if (active) {
            callback.current("")
            setError("No se pudo cargar reCAPTCHA. Recarga la página e intenta nuevamente.")
          }
        }
      })
    }).catch(() => {
      if (active) setError("No se pudo cargar reCAPTCHA. Recarga la página e intenta nuevamente.")
    })
    return () => {
      active = false
      if (widget.current !== null && window.grecaptcha) window.grecaptcha.reset(widget.current)
      widget.current = null
      host.replaceChildren()
    }
  }, [sitekey])

  useEffect(() => {
    if (widget.current !== null && window.grecaptcha) window.grecaptcha.reset(widget.current)
    callback.current("")
  }, [resetCount])

  return <div className="mb-3"><div ref={container} />{error && <p role="alert" className="text-danger">{error}</p>}</div>
}
